import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;
let currentToken: string | null = null;

export function connectInventorySocket(token: string): Socket {
  if (socket?.connected && currentToken === token) {
    return socket;
  }
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }
  const url = import.meta.env.VITE_APP_SERVER_DOMAIN || '';
  socket = io(url, {
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  });
  currentToken = token;
  return socket;
}

export function getInventorySocket(): Socket | null {
  return socket;
}

export function disconnectInventorySocket(): void {
  socket?.removeAllListeners();
  socket?.disconnect();
  socket = null;
  currentToken = null;
}

export type InventoryJoinScope = 'ia_site_visit' | 'tv_site_visit' | 'tv_adjustment' | 'tv_warehouse';

export type InventoryJoinPayload = {
  scope: InventoryJoinScope;
  locationId: number;
  vendingMachineId?: number;
  storageSiteId?: number;
};

export type InventoryCountUpdatedEvent = {
  domain: 'ia' | 'tv_site_visit' | 'tv_adjustment' | 'tv_warehouse';
  locationId: number;
  updatedAt: string;
  updatedByUserId: number | null;
  inventoryItemId: number;
  quantity?: number;
  countDate?: string;
  vendingMachineId?: number;
  parQty?: number;
  fillQty?: number;
  rejectQty?: number;
  recycleQty?: number;
  removed?: boolean;
  storageSiteId?: number;
};

export const INVENTORY_COUNT_UPDATED_EVENT = 'inventory.count.updated';
export const INVENTORY_JOIN_EVENT = 'inventory/join';
export const INVENTORY_LEAVE_EVENT = 'inventory/leave';

export const INVENTORY_POLL_INTERVAL_MS = 10_000;
